module.exports = __webpack_public_path__ + "static/media/Lock.7ba84247.svg";